<template>
  <div class="video">
    <video
      :id="mediaData.id"
      controls
      playsinline
      controlsList="nodownload nofullscreen"
      oncontextmenu="return false;"
      poster=""
      ref="video"
    >
      <source :src="mediaData.url" :type="`video/${mediaData.extension}`" />
      <div>
        <span>Формат видео не поддерживается. </span>
        <a :href="mediaData.url">Скачать</a>.
      </div>
    </video>
  </div>
</template>

<script>
export default {
  name: 'VideoBlock',
  props: {
    mediaData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
video {
  display: block;
  width: 100%;
  height: 220px;
  object-fit: cover;
  &::-webkit-media-controls-fullscreen-button {
    display: none;
  }
}
</style>
